import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { UserServices } from '@/services/apis';
import { ILoggedUser } from '@/infrastructure';

const initialState = {
  users: [],
  tot_count: 0,
  loading: true,
  error: false,
  errorMessage: '',
  status: 'idle',
  loggedUser: {} as ILoggedUser,
  loggedUserOrganisations: [] as any,
  usersForDomainMgmt: [],
  usersCreatedInSetup: [],
  usersCreatedInSetupCount: 0,
  userRoles: {}
};

export const handlingRoles = createAsyncThunk('users/handlingRoles', async ({ roles }: any) => {
  return roles;
});

export const handlingOrganizations = createAsyncThunk('users/handlingOrganizations', async ({ org }: any) => {
  return org;
});

export const fetchUserDetails = createAsyncThunk('users/fetchUserDetails', async ({ userName, domainName }: any) => {
  const data = await UserServices.fetchUserDetails({
    userName,
    domainName
  });

  return data;
});

export const fetchNewCreatedUsers = createAsyncThunk(
  'users/fetchNewCreatedUsers',
  async ({ pagination, userName, domainName, organizationName }: any) => {
    const response = await UserServices.fetchUsers(
      pagination?.page + 1,
      pagination?.rowsPerPage,
      userName,
      domainName,
      '',
      '',
      '',
      '',
      '',
      organizationName
    );
    return response;
  }
);

export const fetchAllUsers = createAsyncThunk(
  'users/fetchAllUsers',
  async ({
    pagination,
    userName,
    domainName,
    roleType,
    roleName,
    groupId,
    roleId,
    organizationId,
    appName,
    appType,
    organizationName
  }: any) => {

    const response = await UserServices.fetchUsers(
      pagination.page + 1,
      pagination.rowsPerPage,
      userName,
      domainName,
      roleType,
      roleName,
      groupId,
      roleId,
      organizationName,
      organizationId,
      appName,
      appType
    );
    return response;
  }
);

export const createUser = createAsyncThunk('users/createNewUser', async (userData: any, thunkAPI) => {
  const response = await UserServices.createUser(userData);
  return response;
});

export const updateUser = createAsyncThunk('users/updateUser', async (userData: any) => {
  const { userId, ...finalData } = userData;
  const data = await UserServices.updateUser(finalData, userId);
  return data;
});

export const getPasswordPolicy = createAsyncThunk('users/getPasswordPolicy', async (data:any) => {
  const {domainName} = data
  const response = await UserServices.getPasswordPolicy({domainName});
  return response;
});

export const lockUser = createAsyncThunk('users/lockUser', async (userData: any) => {
  const data = await UserServices.lockUser(userData);
  return data;
});

export const suspendUser = createAsyncThunk('users/suspendUser', async (userData: any) => {
  const data = await UserServices.suspendUser(userData);
  return data;
});

export const recoverPassword = createAsyncThunk('users/recoverPassword', async (userData: any) => {
  const data = await UserServices.recoverPassword(userData);
  return data;
});

export const deleteUser = createAsyncThunk('users/deleteUser', async (userData: any) => {
  const response = await UserServices.deleteUser(userData?.userId, userData?.domainName, userData?.orgName);
  return response;
});

export const bulkDeleteUser = createAsyncThunk('users/bulkDeleteUser', async (usersData: any) => {
  const response = await UserServices.bulkDeleteUser(usersData);
  return response;
});

export const mappingUser = createAsyncThunk('users/mapping', async (data: any) => {
  try {
    const response = await UserServices.mappingUser(data);
    return response;
  } catch (err) {
    console.log(err);
  }
});

export const uploadUsers = createAsyncThunk(
  'users/uploadUsers',
  async ({ dom_name, data, created_by, modified_by, ask_password, status }: any) => {
    const response = await UserServices.uploadCsv({ dom_name, data, created_by, modified_by, ask_password, status });
    return response;
  }
);

export const downloadUser = createAsyncThunk('users/downloadUser', async () => {
  const response = await UserServices.downloadUser();
  return response;
});

export const UserSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchAllUsers.pending, (state) => {});
    builder.addCase(fetchAllUsers.fulfilled, (state, { payload }) => {
      const finalUsers = payload?.result?.users?.map((item: any) => {
        const role: any = [];
        item.organizations.map((org: any) =>
          org.application.map((app: any) => {
            app.role.map((userrole: any) => {
              role.push({ ...userrole, app_uuid: app.id, app_name: app.name });
            });
          })
        );
        return {
          ...item,
          roles: role
        };
      });

      return {
        ...state,
        users: payload?.result?.users,
        usersForDomainMgmt: finalUsers || [],
        tot_count: payload?.totalRecords,
        loading: false
      };
    });
    builder.addCase(fetchAllUsers.rejected, (state, { payload }) => {
      return { ...state, users: [], usersForDomainMgmt: [], tot_count: 0, loading: false };
    });
    builder.addCase(createUser.fulfilled, (state: any, action) => {});
    builder.addCase(fetchUserDetails.pending, (state) => {
      return { ...state, loading: true, loggedUser: {}, loggedUserOrganisations: [] };
    });
    builder.addCase(fetchUserDetails.fulfilled, (state, { payload }) => {
      return {
        ...state,
        loggedUser: payload?.result?.users[0],
        loggedUserOrganisations: payload?.result?.users[0]?.organizations,
        loading: false
      };
    });
    builder.addCase(fetchUserDetails.rejected, (state) => {
      return { ...state, loading: false, loggedUser: {}, loggedUserOrganisations: [] };
    });
    builder.addCase(fetchNewCreatedUsers.pending, (state) => {});
    builder.addCase(fetchNewCreatedUsers.fulfilled, (state, { payload }) => {
      const finalUsers = payload?.result?.users?.map((item: any) => {
        const role: any = [];
        item.organizations.map((org: any) =>
          org.application.map((app: any) => {
            app.role.map((userrole: any) => {
              role.push({ ...userrole, app_uuid: app.id, app_name: app.name });
            });
          })
        );
        return {
          ...item,
          roles: role
        };
      });
      return {
        ...state,
        usersCreatedInSetup: finalUsers,
        usersCreatedInSetupCount: payload?.totalRecords,
        loading: false
      };
    });
    builder.addCase(fetchNewCreatedUsers.rejected, (state, { payload }) => {
      return { ...state, usersCreatedInSetup: [], usersCreatedInSetupCount: 0, loading: false };
    });
    builder.addCase(handlingRoles.fulfilled, (state, { payload }) => {
      return { ...state, userRoles: payload };
    });
    builder.addCase(handlingOrganizations.fulfilled, (state, { payload }) => {
      return { ...state, loggedUserOrganisations: payload };
    });
  }
});

export const userSelector = (state: any) => state.user;

export default UserSlice.reducer;
